import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

interface TabItem {
    value: string; // The value of the tab, used for the active state
    label: string; // The display label for the tab
  }
  
  interface ColorTabsProps {
    tabs: TabItem[]; // An array of tab items
    handleChange: (event: React.SyntheticEvent, newValue: string) => void; // Function to handle tab change
    tabContent: React.ReactNode ; // Content mapping for each tab
    initialValue?: string; // Optional initial value for the active tab
    activeTab?: string; // Optional active tab value
  }
  
  export default function ColorTabs({
    tabs,
    handleChange,
    tabContent,
    initialValue = tabs[0]?.value || '', // Default to the first tab's value if available
    activeTab
  }: ColorTabsProps) {
    const [value, setValue] = React.useState<string>(initialValue);
  
    const onTabChange = (event: React.SyntheticEvent, newValue: string) => {
      setValue(newValue); // Update local state
      handleChange(event, newValue); // Call external handler
    };
  
    return (
      <Box sx={{ width: '100%' }}>
        <Tabs
          value={activeTab}
          onChange={onTabChange}
          sx={{
            '& .MuiTab-root': {
                color: '#575656',
                fontWeight: 700,
                fontSize: '16px', // Font size for tabs
                textTransform: 'none', // Prevent text transformation
            },
            '& .Mui-selected': {
                color: '#252424 !important', // Text color for tabs
                fontWeight: 700,
                fontSize: '16px', // Font size for active tab
                textTransform: 'none', // Prevent text transformation
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#E51A4B', // Indicator color
            },
          }}
          aria-label="secondary tabs example"
        >
          {tabs.map((tab, index) => (
            <Tab key={index} value={tab.value} label={tab.label} />
          ))}
        </Tabs>
        <Box >
          {tabContent} {/* Render content for the active tab */}
        </Box>
      </Box>
    );
  }
